import { registerMediaModuleAxiosInstance } from '@pba/react-chat-core';
import axios, { type AxiosError, type AxiosResponse } from 'axios';
import qs from 'qs';
// TODO: dont use Response type from api.ts, create new type
import type { ApiClientResponse } from '../api';
import { defaultHeadersInterceptor } from '../interceptors';
// TODO: check if this file should be whole in nodeApiClient - 82948
import { getCurrentNodeToken } from '../node-api';

export const mediaModuleUrl = String(import.meta.env.VITE_APP_MEDIA_MODULE_URL);

export const mediaModuleClient = axios.create({
  baseURL: mediaModuleUrl,
  paramsSerializer(params) {
    return qs.stringify(params, { arrayFormat: 'brackets' });
  },
  responseType: 'json',
  withCredentials: false,
});

mediaModuleClient.interceptors.response.use(
  (response) => normalizeSuccessResponse(response),
  (error: AxiosError) => {
    normalizeErrorResponse(error);
  },
);

// TODO: Refactor after Axios update (see PBA files for reference)
mediaModuleClient.interceptors.request.use((config) => {
  const headers = config.headers as Record<string, unknown>;
  // TODO: this function must be placed in different file and also cover the case when token is not set by itself
  const accessToken = getCurrentNodeToken();
  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
});

mediaModuleClient.interceptors.request.use(defaultHeadersInterceptor);

registerMediaModuleAxiosInstance({ instance: mediaModuleClient });

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
function normalizeErrorResponse(error: any) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  if (error.response?.status === 401) {
    // TODO change one day to new logout
  }

  throw error;
}

function normalizeSuccessResponse<T>(response: AxiosResponse<T>): ApiClientResponse<T> {
  return response;
}
